import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import routes from './routes';
import store from '../store/index';

if(process.env.VUE_APP_DEVICE == 'desktop') {
  var router = new VueRouter({
    mode: 'history',
    base: '/' + store.getters['language/getLanguage'],
    store,
    routes,
    scrollBehavior() {
        return {x: 0, y: 0}
    }
  })
}
else {
  var router = new VueRouter({
    mode: '',
    store,
    routes,
    scrollBehavior() {
        return {x: 0, y: 0}
    }
  })
}

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth == true && !store.getters['auth/getLoginStatus']) {
      next({ name: 'login', params: {from: to.name} });
  }
  else {
      next();
  }
})

export default router;